<template>
    <v-select
            :label="(label)? label : 'Seleccione moneda'"
            :items="monedas"
            :value="value"
            :multiple="multiple"
            :error-messages="errores.collect('moneda')"
            item-avatar="avatar"
            small-chips
            hide-selected
            v-validate="validate"
            data-vv-name="moneda"
            required
            @input="actualizaValor($event)"
            @change="change($event)"
    >
    </v-select>
</template>
<script>
    export default {
        name: 'moneda-select',
        props: ['multiple', 'label', 'filtro', 'value', 'chips', 'validate'],
        data() {
            return {
                monedas: [
                    {value: 1, text: 'Peso', avatar: './img/iso-1.svg'},
                    {value: 2, text: 'Dolar', avatar: './img/iso-2.svg'},
                ],
                moneda: ''
            }
        },
        methods: {
            actualizaValor(valor) {
                this.$emit('input', valor)
            },
            change(e) {
                this.$emit('change', e);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/MonedaSelect.vue